import React, { Suspense, useEffect, useMemo, useState } from 'react'

import Grid from '@material-ui/core/Grid'
import { GridItem } from 'Components/Page/StatsPageWrapper'
import Loader from '../../../HighchartsCharts/components/Loader'
import ChartHeader from '../ChartHeader'
import { OPTIONS_FILTERS_ENUM_TYPES, selectOptions } from '../options'
import { getIsPositive, getPastDates, getPeriodDiff } from '../utils'

const Chart = React.lazy(() => import('Components/Chart'))

const startData = { amount: 0, items: {} }

const ScanColumnsGraph = ({
  scansData,
  dateNow,
  formatData,
  chartOptions,
  scansTitle,
}) => {
  const [options, setOptions] = useState(chartOptions)
  const [selectedFilter, setSelectedFilter] = useState(
    OPTIONS_FILTERS_ENUM_TYPES.LAST_7_DAYS,
  )

  const [filteredScanData, setFilteredScanData] = useState(startData)

  const [previousFilteredScanData, setPreviousFilteredScanData] = useState(
    startData,
  )

  const [previousDate, setPreviousDate] = useState(
    getPastDates(dateNow, selectedFilter),
  )

  useEffect(() => {
    setPreviousDate(getPastDates(dateNow, selectedFilter))
  }, [selectedFilter])

  useEffect(() => {
    const actualScanData = scansData.filter(
      item =>
        +item.createdAt > previousDate && +item.createdAt < dateNow.valueOf(),
    )
    const formatActualData = formatData({
      data: actualScanData,
    })
    setFilteredScanData(formatActualData)

    const startPreviousPreviousDate = getPastDates(previousDate, selectedFilter)
    const previousPreviousData = scansData.filter(
      item =>
        +item.createdAt > startPreviousPreviousDate &&
        +item.createdAt < previousDate.valueOf(),
    )
    const formatPreviousScanData = formatData({
      data: previousPreviousData,
    })
    setPreviousFilteredScanData(formatPreviousScanData)
  }, [previousDate])

  useEffect(() => {
    setOptions(prev => ({
      ...prev,
      xAxis: {
        categories: [
          ...Object.keys(filteredScanData.items).map(item =>
            item && item !== 'null' ? item : 'Unknown',
          ),
        ],
      },
      series: [
        {
          data: Object.values(filteredScanData.items),
        },
      ],
    }))
  }, [filteredScanData])

  const handleFormChange = item => {
    if (item.isDirty) {
      setSelectedFilter(item.value)
    }
  }

  const amountDiff = getPeriodDiff(
    filteredScanData.amount,
    previousFilteredScanData.amount,
  )

  const statsOptions = useMemo(
    () => [
      {
        title: scansTitle,
        value: filteredScanData.amount,
        isPositive: getIsPositive(amountDiff),
        diff: Math.abs(amountDiff),
      },
    ],
    [filteredScanData, amountDiff],
  )

  return (
    <div>
      <GridItem>
        <Suspense fallback={<Loader />}>
          <Grid container>
            <Grid item xs={12}>
              <ChartHeader
                statsOptions={statsOptions}
                selectOptions={selectOptions}
                handleFormChange={handleFormChange}
                selectedValue={selectedFilter}
              />
            </Grid>
            <Grid item xs={12}>
              <Chart options={options} />
            </Grid>
          </Grid>
        </Suspense>
      </GridItem>
    </div>
  )
}

export default ScanColumnsGraph



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/Charts/ScanColumnsGraph/index.js